/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LabelledField from "components/labelled-field/index";
import { SimplicityTreeView } from "components/tree/website/simplicity-tree-view";
// import { useGetCurrentNavTree } from 'hooks/useGetCurrentNavTree'
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { readWebpageNav } from "utils/read-webpage";
// import {setWebsiteNavigationTree} from 'data/store/reducers/website'
import { useAuth } from "cms/auth/hooks/use-auth";
import { useGetCurrentWebsite } from "hooks/use-current-website";

const ComponentBrowse = (props) => {
    
    const {
        // root,
        hideTree,
        selectNode,
        selectedPageTitle
    } = props;
    
    // const root = useGetCurrentNavTree()
    const { currentWebsite: website } = useGetCurrentWebsite();
    const [root, setRoot] = useState();
    const { token } = useAuth()
    
    
    // Load the navigation tree data
    useEffect(() => {
        const fetchData = async (token, website) => {
            if (website) {
                const { home } = website || {};
                if (home) {
                    const home_tree = await SimpliCityAdminSDK.webpage.findTree(token, home);
                    if (home_tree) {
                        const found_root = await readWebpageNav(home_tree);
                        setRoot(found_root);
                    }
                }
            }
        };
        fetchData(token, website);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='pageSelectorContainerStyle'>
            <div className='selectorHeaderStyle'>
                <div
                    className='selectorHeaderTextStyle'
                    dangerouslySetInnerHTML={{ __html: selectedPageTitle }}
                ></div>
                <div>
                    <Button
                        startIcon={<CloseIcon />}
                        onClick={hideTree}
                        variant='text'
                        color='neutral'
                        size='small'
                    ></Button>
                </div>
            </div>
            <div className='treeContainerStyle'>
                <LabelledField label='Navigation Pages'>
                    <SimplicityTreeView
                        root={root}
                        selectNode={selectNode}
                    />
                </LabelledField>
            </div>
        </div>
    );
};
ComponentBrowse.displayName = "ComponentBrowse";
export { ComponentBrowse };
